import { memo } from 'react';
import { selectIsUserLoggedIn } from '@bridebook/web/lib/users/selectors';
import { useSelector } from '@bridebook/web/lib/utils';
import ProtectedHeader from './protected-header';
import PublicHeader from './public-header';

const Header = () => {
  const isLoggedIn = useSelector(selectIsUserLoggedIn);

  // Required as /reviews page is accessible for both - logged in and out users
  // with full layout enabled
  return isLoggedIn ? <ProtectedHeader /> : <PublicHeader />;
};

export default memo(Header);
